import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createMarkup } from '../Helpers/FormHelper';

export function Payment({ paygovMessage, donationStatus }) {
  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card benefit-tile">
            <div className="card-body">
              <h4 className="card-title"><strong>{donationStatus}</strong></h4>
              <p className="card-text" style={{ whiteSpace: "pre-line" }} dangerouslySetInnerHTML={createMarkup(paygovMessage)}></p>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6 text-start">
          <Link to={
            { pathname: "/" }
          } className="btn blm-btn-primary left" type="button"><FontAwesomeIcon icon={["fa", "angle-double-left"]} />  Return to Home</Link>
        </div>
      </div>
    </div>
  );
}

Payment.propTypes = {
  paygovMessage: PropTypes.string,
  donationStatus: PropTypes.string,
}
